(function initReceiptInboxDuplicateReview(global) {
  const applyExactFileGuard = (review, duplicateUpload, status) => {
    if (['trashed', 'trash'].includes(String(status || '')) || status === 'booked' || duplicateUpload?.reason !== 'file') return review;
    return {
      status: 'needs-review',
      label: 'Trenger kontroll',
      reasons: [...new Set([...(review?.reasons || []), 'Nøyaktig samme fil finnes allerede i bilagsinnboksen eller er bokført.'])],
      notes: review?.notes || [],
    };
  };
  global.PlummeReceiptInboxDuplicateReview = { applyExactFileGuard };
})(window);
